import React, {useEffect, useRef} from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import DefaultSettings from '../settings';
import Link from '@material-ui/core/Link';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { GetData, PostData } from '../../helpers/requests';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Plugin_PostData } from '../../helpers/plugins/pluginrequests';
import { createRequest } from '../../helpers/rest';


const STATUS_LIID = "327";
const CYCLE_LIID = 281;
const PURPOSE_ID = 2;

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiButton-root": {
            fontSize: 11
        }
    },
    blinkingButton: {
        animation: `$blinking 1s infinite`,
        color: 'red'
    },
    "@keyframes blinking": {
        "0%": { opacity: 1 },
        "50%": { opacity: 0 },
        "100%": { opacity: 1 }
    },
    message: {
        marginTop: theme.spacing(2),
        color: 'red',
        fontWeight: 'bold'
    },
    greenLink: {
        color: 'green',
        fontWeight: 'bold'
    }
}));

function EPRReviewButton({ ...props }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [isVisible, setIsVisible] = React.useState(false);
    const [highlight, setHighlight] = React.useState(true);
    const [plugintSettings, setPlugintSettings] = React.useState(true);
    const fieldValues = props?.fieldValues || {};
    const applicationStatus = fieldValues['APPLICATION_STATUS'] || null;
    const applicationnumber = fieldValues['APPLICATION_NO'] || null;
    const [recordid, setRecordId] = React.useState(fieldValues['RECORD_ID'] || null);
    const [eprProjectNumber, setEPRProjectNumber] = React.useState(fieldValues['EPR_PROJECT_NUMBER'] || null);
    const [sitePermitTypeId, setSitePermitTypeId] = React.useState(fieldValues['SITE_PERMIT_TYPE_ID'] || null);     
    const [staticParams, setStaticParams] = React.useState({        
        "status_LIID": STATUS_LIID, 
        "cycle_LIID": CYCLE_LIID,
        "purpose_id": PURPOSE_ID
    });
    const isInternal = getEnvVariable('AccessPortal') === 'I';
    const prevApplicationStatusRef = useRef();

    useEffect(() => {
        // GET EPR plugin settings
          loadPageData();
    }, []);

    const loadPageData = () => {
        if(getEnvVariable('HasExternalPlugins') === 'Y'){
            //DefaultSettings.getAlert().show('You are reviewing for project'+recordid, 'info');
            IsProjectExists().then(res => {
                if(!res){
                  loadInitialData();
                }  
              })        
        }     
    }

    useEffect(() => {
        loadPageData();
    }, [applicationStatus, applicationnumber]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        const eprurl = `${getEnvVariable('PluginsAPI')}/api/EPRProjectTypes/${plugintSettings['EPRProjectTypeId']}`;
        GetData(eprurl).then(res =>{
            if(res){
                const projenumber = `${getEnvVariable('ModuleKey')}-${res['Abbreviation']}-${applicationnumber}`;
                const projreferencenumber = `${getEnvVariable('InternalBasepath')}`
                const creatparams = {
                    "projectNumber": projenumber,
                    "name": projenumber,
                    "referenceNumber": projreferencenumber,
                    "projectType_LIID": res['Id'],
                    "vendor_id": recordid,
                    ...staticParams
                }
                console.log(creatparams);
                Plugin_PostData(`${getEnvVariable('EPRPartnerAPI')}/projects`, creatparams, true, null).then(res => {
                    console.log(res);
                    if(res && res['success'] && res.data){
                        createInternalReference(res);
                        //DefaultSettings.getAlert().show('Review Project Created Successfully','success');
                    }
                }, err => {
                    console.log(err);
                    err.then(errorres =>{
                        console.log(errorres);
                        DefaultSettings.getAlert().show(errorres.message, 'error');
                    })                    
                })
            }            
        })
       
        setOpen(false);
    };

    const createInternalReference = (eprres) => {
        const createurl = `${getEnvVariable('PluginsAPI')}/api/EPRProjects/Add`;
        let projectcreationdata = {
            RefId: recordid,
            SitePermitTypeId:sitePermitTypeId,
            EPRProjectId: eprres.data.id, 
            ProjectNumber: eprres.data.projectNumber, 
            ProjectName: eprres.data.name                
        };
        PostData(createurl,projectcreationdata, true, 'Reference Added Successfully!' ).then(res => {
            if(res && res.Id){
                setEPRProjectNumber(res['ProjectNumber']);
                setVisiblitity();                
            }            
        })
    }

    const setMasterTableData = (data) => {
        try {
            let request = {
                url: getEnvVariable('Application') + `/api/Application/UpdateFields/${sitePermitTypeId}/${recordid}`,
                type: 'put',
                alert: true,
                body: data
            }
            createRequest(request, request.body, null).then(res => {
                console.log(res);
            })
        } catch (error) {
            console.log(error);
        }
    }

    const loadInitialData = () => {        
        if(applicationnumber && isInternal){
            const url = `${getEnvVariable('AdminConfig')}/api/SitePermitTypesConfig/ExternalPlugins/${sitePermitTypeId}/Get`;        
            GetData(url).then(res =>{
                console.log(res);
                if(res && res['HasEPRPlugin'] == 'Y') {
                    setPlugintSettings(res);
                    const roles = res['EPRRoles']?.split(',') || [];
                    const userroles = JSON.parse(localStorage.getItem('profile')).modulePermissions;                    
                    let roleidlist = userroles.map(ur => ur.roleId);                
                    console.log(roles, roleidlist);
                    if(roles.some(r => roleidlist.some(ur => ur == r))){
                        setVisiblitity()
                    }
                }
            })
        }
    }

    const IsProjectExists = () => {
        return new Promise((resolve, reject) => {
            if(recordid){
                const url = `${getEnvVariable('PluginsAPI')}/api/EPRProjects/Record/${recordid}`;
                GetData(url).then(res => {
                    if(res && res.Id){
                        setEPRProjectNumber(res['ProjectNumber']);
                        setVisiblitity();
                        resolve(true);
                    }else{
                        resolve(false);
                    }
                })       
            }else{
                resolve(false);
            }               
        })
    }

    const setVisiblitity = () => {
        try {
            setIsVisible(true);
            const timer = setTimeout(() => {
                setHighlight(false);
            }, 5000);
            return () => clearTimeout(timer);
        } catch (error) {
            
        }
    }

    return (
        isVisible && (<div className={classes.root}>
            {eprProjectNumber ? (
                <Typography variant="caption" color='colorSecondary'><b>{'EPR Project Number: '+eprProjectNumber + ' '}</b></Typography>
                // <IconButton size='small' color='primary'
                //     title={'Under EPR Review'+eprProjectNumber}
                //     onClick={() => {
                //         console.info("Project is under review. Nothing to show!");
                //     }}
                // >   
                //     {/* <QueuePlayNextIcon fontSize="small"  color='secondary'/>  */}
                //     {getEnvVariable('IconTitle') === 'Y' 
                //     && <Typography variant="caption" color='primary'>{'Under EPR Review'+eprProjectNumber}</Typography>}
                // </IconButton>   
                // <Grid container alignItems="center" spacing={1}>
                //     {highlight && (
                //         <Grid alignItems="center" item>
                //             <Typography align='center' variant="body2" className={classes.message}>
                //                 This project is under EPR review
                //             </Typography>
                //         </Grid>
                //     )}
                //     <Grid item alignItems="center">
                //         <Link
                //             component="button"
                //             variant="body2" 
                //             className={classes.greenLink}
                //             onClick={() => {
                //                 console.info("Project is under review. Nothing to show!");
                //             }}
                //         >
                //         <b>{eprProjectNumber}</b> 
                //         </Link>  
                //     </Grid>
                       
                // </Grid>
                           
            ) : (
                <>
                    <IconButton size='small' color='primary'
                        title={'Create Review Project'}
                        onClick={handleClickOpen}
                    >   
                        <QueuePlayNextIcon fontSize="small"  color='secondary'/> 
                        {getEnvVariable('IconTitle') === 'Y' 
                        && <Typography variant="caption" color='primary'>{'Create EPR Review Project'}</Typography>}
                    </IconButton>    
                    {/* <Grid container alignItems="center" spacing={1}>
                        {highlight && (
                            <Grid item alignItems="center">
                                <Typography align='center' variant="body2" className={classes.message}>
                                    Project documents can be sent to review
                                </Typography>
                            </Grid>
                        )}
                        <Grid item>
                            <IconButton
                                color="primary"
                                onClick={handleClickOpen}
                                className={highlight ? classes.blinkingButton : ''}
                            >
                                <QueuePlayNextIcon />
                            </IconButton>
                        </Grid>
                    </Grid> */}
                    
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Send to Review"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Would you like create a project for review?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>                           
                            <Button onClick={handleConfirm} color="primary" autoFocus>
                                Yes
                            </Button>
                            <Button onClick={handleClose} color="primary">
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>)
    );
}

export default EPRReviewButton;